import type { AiBusinessCenterModule } from '../types'

export const crmModule: AiBusinessCenterModule = {
  key: 'crm',
  label: 'CRM客户管理系统',
  desc: '客户管理 / 商机跟进 / 合同管理 / 数据分析',
  path: '/crm',
  homePath: '/crm/dashboard',
  icon: 'ep:user-filled',
  color: '#3b82f6',
  aliases: ['CRM管理', 'CRM系统', 'CRM 系统']
}
